export default theme => {
    return {
      mainLabel: {
        fontFamily: 'OktaNeueRegular',
        fontWeight: 500
      }
    }
}
